export default __webpack_public_path__ + "static/media/logo.056ba1a1.svg";